import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { IncomeData } from '../../useIncome';
import { BusinessFormValues, dataToForm, UpsertIncomeDTO, Validation } from './BusinessForm.meta';
import { IncomeModel, IncomeType } from '../../api/useIncomeQuery';
import { useUpsertIncomeMutation } from '../../api/useUpsertIncomeMutation';
import { toast } from '../../../../CommonComponents/OPL/Toast/Toast';
import {
  ADD_INCOME_SUCCESS_MESSAGE,
  EDIT_INCOME_SUCCESS_MESSAGE,
  getShowAdvanced,
} from '../../Income.meta';

interface Params {
  clientId: string;
  income: IncomeModel | null;
  data: IncomeData;
  onSuccess: () => void;
  readOnly?: boolean;
}

export const useBusinessForm = ({ clientId, income, data, onSuccess, readOnly }: Params) => {
  const formBag = useForm<BusinessFormValues>({
    defaultValues: dataToForm(income, data.Options),
    resolver: yupResolver(Validation),
    disabled: readOnly,
  });

  const mutationBag = useUpsertIncomeMutation({ clientId });

  const defaultShowAdvanced = !!income && getShowAdvanced(income);

  const onSubmit = formBag.handleSubmit(async (values: BusinessFormValues) => {
    const body: UpsertIncomeDTO = {
      clientId,
      ...values,
      EndAge: values.EndAtRetirement ? null : values.EndAge ?? null,
      id: income?.Id || null,
      IncomeType: IncomeType.Business,
    };

    try {
      await mutationBag.mutateAsync(body);

      toast.success(income?.Id ? EDIT_INCOME_SUCCESS_MESSAGE : ADD_INCOME_SUCCESS_MESSAGE);

      onSuccess();
    } catch (error) {
      console.error(error);
    }
  });

  return {
    data: {
      formBag,
      defaultShowAdvanced,
      mutationBag,
    },
    actions: {
      onSubmit,
    },
  };
};
